<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <p class="content-s-2-label">
      <label
      >Соглашение о сотрудничестве:</label
      >
    </p>
    <div
      class="col-xs-12 mycol"
      :class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_CONG_FEDERAL_PROJECT_COOPERATION'
          )
        }"
    >
        <textarea
          class="i-main-style t-dop-style i-wid-50"
          v-model="project.SETTING_TABLE.allData.UF_CONG_FEDERAL_PROJECT_COOPERATION"
          placeholder=""
          style="resize: vertical;"
          v-on:keyup="
           $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_CONG_FEDERAL_PROJECT_COOPERATION')
         "
        ></textarea>
      <div class="error-text" style="padding-bottom: 10px;">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_CONG_FEDERAL_PROJECT_COOPERATION"
          )
        }}
      </div>
    </div>

    <p class="content-s-2-label">
      <label
      >Протокол выполнения мероприятий<template v-if="isRobotizationDirection">/Протокол о роботизации</template>:</label
      >
    </p>
    <div
      class="col-xs-12 mycol"
      :class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_CONG_FEDERAL_PROJECT_PROTOCOL'
          )
        }"
    >
        <textarea
          class="i-main-style t-dop-style i-wid-50"
          v-model="project.SETTING_TABLE.allData.UF_CONG_FEDERAL_PROJECT_PROTOCOL"
          placeholder=""
          style="resize: vertical;"
          v-on:keyup="
           $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_CONG_FEDERAL_PROJECT_PROTOCOL')
         "
        ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_CONG_FEDERAL_PROJECT_PROTOCOL"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ConfirmFederalProject",
  computed: {
    isRobotizationDirection() {
      let id = this.project.UF_DIRECTION_FINANCING_ID;
      if (!(id > 0)) return false;
      let dir = (this.directory.sp_direction_financing || []).find(function(
        item
      ) {
        return item.ID == id;
      });
      return !!dir && dir.CODE === "robotization_of_production";
    },
    ...mapGetters(["project", "directory"])
  },
  methods: {
  }
};
</script>

<style scoped></style>
